import { contrastRatio } from '@yola/yola-palette-generator';
import isDark from '../../../common/verifiers/is-dark';
import increaseColorPointByRatio from '../../../common/utils/increase-color-point-by-ratio';
import reduceColorPointByRatio from '../../../common/utils/reduce-color-point-by-ratio';

const primary = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'decoration.background.primary',
    params,
  };
  if (!isDark(backgroundColor)) {
    return increaseColorPointByRatio({
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    });
  }

  if (contrastRatio(backgroundColor, targetColorPalette[900]) >= 1.5) {
    return increaseColorPointByRatio({
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.5,
      fallback,
    });
  }

  return reduceColorPointByRatio({
    targetColor,
    backgroundColor,
    targetColorPalette,
    condition: (ratio) => ratio >= 1.5,
    fallback,
  });
};

export default primary;
